module.exports = __webpack_public_path__ + "static/16-9137b7bf1e40e84b20a710768bbf1bec.jpg";